import { Controller } from "react-hook-form";
import { FormLabel } from "../FormLabel";
import { FormErrorLabel } from "../FormErrorLabel";
import { Combobox } from "../Combobox";

const FormCombobox = ({
  name,
  label,
  control,
  error,
  isRequired,
  options,
  onChange: onSelectChange,
  ...rest
}: any) => {
  return (
    <div className="relative flex flex-col items-start gap-1">
      {label && (
        <FormLabel>
          {label} <span className="text-red-700">{isRequired ? "*" : ""}</span>
        </FormLabel>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          return (
            <Combobox
              options={options}
              {...field}
              {...rest}
              value={rest.multiSelect ? field?.value : field.value?.toString()}
              defaultValue={field.value?.toString()}
              onSelect={(value: any) => {
                onSelectChange && onSelectChange(value);
                field.onChange(value);
              }}
            />
          );
        }}
      />
      {error && <FormErrorLabel>{error}</FormErrorLabel>}
    </div>
  );
};

export default FormCombobox;
